import * as S from './PremiumFrame.styles'
import {
  type FRAME_COLORS,
  type MATERIAL_TYPES,
  type MATTING,
} from '@mixtiles/web-backend-shared'
import { getOptimizedUrl } from '../../../../../services/CloudinaryService'

type Props = {
  materialType: MATERIAL_TYPES
  frameColor: FRAME_COLORS
  matting: MATTING
  imageUrl: string
}

export function getFrameImage(
  materialType: MATERIAL_TYPES,
  frameColor: FRAME_COLORS
) {
  const assetDirectory = `assets/art/homepage/frames//${materialType}-${frameColor}`
  return getOptimizedUrl(assetDirectory)
}

function PremiumFrame({ materialType, frameColor, matting, imageUrl }: Props) {
  return (
    <S.Container>
      <S.Frame src={getFrameImage(materialType, frameColor)} />
      <S.Image src={imageUrl} $matting={matting} $materialType={materialType} />
    </S.Container>
  )
}

export default PremiumFrame
